// src/constants/regex.ts
var REGEX_PLAYER_LICENSEY_KEY = /^[\d\w+_/=]{48,64}$/;
var REGEX_ACCOUNT_ID = /[a-z0-9]{8}/gim;
var REGEX_ACCOUNT_UUID = /^[\d\w-]{36}$/;
var REGEX_ANALYTICS_TOKEN = /^[\d\w+_]{22}$/;

export { REGEX_ACCOUNT_ID, REGEX_ACCOUNT_UUID, REGEX_ANALYTICS_TOKEN, REGEX_PLAYER_LICENSEY_KEY };
